
















import { Vue, Component, Ref } from 'vue-property-decorator'
import { Dialog } from 'quasar'
import ModalDialog from 'components/modals/Dialog.vue'
import locales from 'src/i18n'

const actions: { command: string, label: string }[] = []
for (const locale in locales) {
  actions.push({
    command: locale,
    label: locales[locale].messages.langname
  })
}

@Component({
  components: {
    ModalDialog
  }
})
export default class LocaleSelect extends Vue {
  actions = actions

  @Ref()
  readonly dialog!: ModalDialog

  show () { this.dialog.show() }
  hide () { this.dialog.hide() }
}

export async function select (parent: Vue): Promise<string> {
  return new Promise((resolve, reject) => {
    const dialog = Dialog.create({
      parent,
      component: LocaleSelect
    }).onOk((locale: string) => {
      resolve(locale)
      dialog.hide()
    })
  })
}
